<template>
    <div>
        <h2 class="section-title small-20 columns">{{configurations.itemTitle}}</h2>
        <div class="row">
            <post :postData="post" :index="index" v-for="(post,index) in allPosts" :key="post.id"></post>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import SocialMedia from "../../../../_Api/SocialMedia";
import Post from "./Post.vue";
export default {

    components: {
        Post
    },
    data() {
        return {
            allPosts: [],
            loading: true,
            retries: 0,
        }
    },
    mounted() {
        this.startComponent();
    },
    computed: {
        ...mapGetters( [ "translationHelper", "configurations" ] )
    },
    methods: {
        startComponent() {
            this.loadPosts();
        },
        loadPosts() {
            SocialMedia.getPosts( this.configurations.selectedBroadcastFilters,
                ( data ) => {
                    this.allPosts = data;

                }, () => {},
                () => {
                    this.loading = false;
                } );
        }
    }
}
</script>
